<div class="gt-routes-list-containerss">
  <span
    i18n="@@descriptionAdminTrafficLight"
    style="color: var(--color-grey-500); font-size: 14px"
    >Set thresholds for when the status (color) of milestones should
    change.</span
  >
  <form (submit)="$event.preventDefault(); saveTrafficConfigurations($event)">
    <dx-form [colCount]="1" validationGroup="taskConfigForm">
      <!-- Green Section -->
      <dxi-item>
        <div class="traffic-section traffic-green">
          <div class="traffic-header">
            <span class="traffic-dot green"></span>
            <strong i18n="@@green">Green</strong>
          </div>
          <div class="traffic-body">
            <span i18n="@@timelineStatusMilestone"
              >Milestone should be green</span
            >
            <dx-number-box
              [(value)]="trafficLightItems.greenLimitDays"
              (onValueChanged)="updateTimeline($event)"
              [min]="0"
              [valueChangeEvent]="'keyup'"
            ></dx-number-box>
            <span i18n="@@days">days</span>
            <dx-select-box
              [(value)]="trafficLightItems.greenBefore"
              (onValueChanged)="propagateChanges()"
              [items]="directions"
              displayExpr="label"
              valueExpr="value"
            ></dx-select-box>
            <span i18n="@@dueDateGreen">due date.</span>
          </div>
        </div>
      </dxi-item>

      <!-- Yellow Section -->
      <dxi-item>
        <div class="traffic-section traffic-yellow">
          <div class="traffic-header">
            <span class="traffic-dot yellow"></span>
            <strong i18n="@@yellow">Yellow</strong>
          </div>

          <div class="traffic-body">
            <span i18n="@@timelineStatusMilestone"
              >Milestone should be yellow</span
            >
            <dx-number-box
              [(value)]="trafficLightItems.yellowLimitDays"
              (onValueChanged)="updateTimeline($event)"
              [min]="0"
              [valueChangeEvent]="'keyup'"
            ></dx-number-box>
            <span i18n="@@days">days</span>
            <dx-select-box
              [(value)]="trafficLightItems.yellowBefore"
              (onValueChanged)="propagateChanges()"
              [items]="directions"
              displayExpr="label"
              valueExpr="value"
            ></dx-select-box>
            <span i18n="@@dueDateYellow">due date.</span>
          </div>
        </div>
      </dxi-item>

      <!-- Red Section -->
      <dxi-item>
        <div class="traffic-section traffic-red">
          <div class="traffic-header">
            <span class="traffic-dot red"></span>
            <strong i18n="@@red">Red</strong>
          </div>
          <div class="traffic-body">
            <span i18n="@@timelineStatusMilestone"
              >Milestone should be red</span
            >
            <dx-number-box
              [(value)]="trafficLightItems.redLimitDays"
              (onValueChanged)="updateTimeline($event)"
              [min]="0"
              [valueChangeEvent]="'keyup'"
            ></dx-number-box>
            <span i18n="@@days">days</span>
            <dx-select-box
              [(value)]="trafficLightItems.redBefore"
              (onValueChanged)="propagateChanges()"
              [items]="directions"
              displayExpr="label"
              valueExpr="value"
            ></dx-select-box>
            <span i18n="@@dueDateRed">due date.</span>
          </div>
        </div>
      </dxi-item>

      <!-- Timeline Preview -->
      <dxi-item class="timeline-container">
        <app-timeline [statusConfigs]="trafficLightTimeline"></app-timeline>
      </dxi-item>

      <dxi-item>
        <dx-check-box
          [(value)]="trafficLightItems.reminderVisible"
          i18n-text="@@trafficLightNotification"
          text="Send notification for the project's traffic status"
        ></dx-check-box>
      </dxi-item>

      <dxi-item>
        <div class="gt-flex-dir-row justify-end">
          <app-gpd-button
            icon="tick"
            i18n-text="@@save"
            text="Save"
            validationGroup="taskConfigForm"
            [useSubmitBehavior]="true"
          ></app-gpd-button>
        </div>
      </dxi-item>
    </dx-form>
  </form>
</div>
